import { Typography } from '@mui/material';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

interface SectionHeaderProps {
  message: MessageDescriptor;
  count: number;
  values?: Record<string, string | number>;
}

/**
 * Secondary heading for a status-screen station group (favorites, own, shared, or named group).
 */
export function SectionHeader({ message, count, values }: SectionHeaderProps) {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        display: 'block',
        mb: 1.5,
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
      }}
    >
      <FormattedMessage {...message} values={{ count, ...values }} />
    </Typography>
  );
}
